/**
 * Shared environment configuration constants
 * Single source of truth for all environments, hostnames, and telemetry values
 * Used by both JS and HTML for consistent environment detection
 */

export const API_ENDPOINTS = {
  production: 'https://eventbeyondapi.emt.aws.gartner.com/',
  'prod-dr': 'https://eventbeyondapi-use2.emt.aws.gartner.com/',
  qa: 'https://eventbeyondapi.emtqa.aws.gartner.com/',
  'qa-dr': 'https://eventbeyondapi-use2.emtqa.aws.gartner.com/',
  uat: 'https://eventbeyondapi-uat.emtqa.aws.gartner.com/',
  dev: 'https://eventbeyondapi.emtdev.aws.gartner.com/',
  localhost: 'http://localhost:3000/'
}

export const GTM_IDS = {
  production: 'GTM-K74BFSX',
  'prod-dr': 'GTM-K74BFSX',
  qa: 'GTM-5PK42SH',
  'qa-dr': 'GTM-5PK42SH',
  uat: 'GTM-5PK42SH',
  dev: 'GTM-5PK42SH'
}

export const DYNATRACE_URLS = {
  production: 'https://js-cdn.dynatrace.com/jstag/157944990f8/bf28149orj/bef60dcc83e5f047_complete.js',
  'prod-dr': 'https://js-cdn.dynatrace.com/jstag/157944990f8/bf28149orj/bef60dcc83e5f047_complete.js',
  qa: 'https://js-cdn.dynatrace.com/jstag/165658ccba3/bf61707uff/5c72120d802d4b76_complete.js',
  'qa-dr': 'https://js-cdn.dynatrace.com/jstag/165658ccba3/bf61707uff/5c72120d802d4b76_complete.js',
  uat: 'https://js-cdn.dynatrace.com/jstag/165658ccba3/bf61707uff/5c72120d802d4b76_complete.js',
  dev: 'https://js-cdn.dynatrace.com/jstag/dev/complete.js'
}

// Shared telemetry values (same across all environments)
export const SHARED_TELEMETRY = {
  rollbarToken: 'ba1e7a2cadf44f7d80af648233212e54'
}

// Exact hostname to environment mappings
export const HOSTNAME_TO_ENV = {
  'my.evanta.com': 'production',
  'my-use2.evanta.com': 'prod-dr',
  'uat-my.evanta.com': 'uat',
  'qa-my.evanta.com': 'qa',
  'qa-use2-my.evanta.com': 'qa-dr',
  'dev-my.evanta.com': 'dev'
}

/**
 * Detect environment from hostname using pattern matching
 * Checks exact hostnames first, then substring patterns
 */
export const detectEnvironmentFromHostname = (hostname) => {
  if (!hostname) return 'dev'

  const lowerHostname = hostname.toLowerCase()

  // Check exact hostname mapping first (most specific)
  if (HOSTNAME_TO_ENV[lowerHostname]) {
    return HOSTNAME_TO_ENV[lowerHostname]
  }

  // Fallback substring matching (order matters: check most specific patterns first)
  if (lowerHostname.includes('localhost') || lowerHostname.includes('127.0.0.1')) {
    return 'localhost'
  }

  if (lowerHostname.includes('qa-use2') || lowerHostname.includes('qadr')) {
    return 'qa-dr'
  }

  if (lowerHostname.includes('use2')) {
    return 'prod-dr'
  }

  if (lowerHostname.includes('uat')) {
    return 'uat'
  }

  if (lowerHostname.includes('qa')) {
    return 'qa'
  }

  if (lowerHostname.includes('dev')) {
    return 'dev'
  }

  // Default to dev for unknown hostnames
  return 'dev'
}
